import { createSlice } from "@reduxjs/toolkit";

const initialItemState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  totalPerPage: 10,
  totalPerPageCount: 0,
  pageNumber: 1,
  entities: null,
  lastError: null,
  itemForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const itemSlice = createSlice({
  name: "item",
  initialState: initialItemState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		itemFetched: (state, action) => {
      const { meta, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = meta ? meta.total : entities.length;
      state.totalPerPage = meta ? meta.per_page : 10;
      state.totalPerPageCount = meta ? meta.to : 0;
      state.pageNumber = meta ? meta.current_page : 1;
    },
    itemCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.item.push(action.payload.item);
    },
    itemDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.item.filter(el => el.item_id !== action.payload.id);
    },
    getItem: (state, action) => {
      state.actionsLoading = false;
      state.itemForEdit = action.payload.itemForEdit;
      state.error = null;
    },
    // updateProduct
    itemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.item = state.entities.item.map(entity => {
        if (entity.item_id === action.payload.item.item_id) {
          return action.payload.item;
        }
        return entity;
      });
    },
  },
});
